import React, { useState } from "react"
import Box from "@mui/material/Box"
import CustomButton from "../../custom-button"
import { useDeleteAppliancePlan } from "../../../hooks/use-appliance-plan"


export default function DeleteAppliancePlanForm({
    appliancePlanId,
    applianceId,
    returnToList,
}: {
    appliancePlanId: number,
    applianceId: string | undefined,
    returnToList: Function,
}) {

    const [confirmation, setConfirmation] = useState<boolean>(false)

    const mutation = useDeleteAppliancePlan(appliancePlanId, applianceId, returnToList)

    return (
        <Box>
            <Box display="flex" justifyContent="center" gap={1} mt={2}>
                {!confirmation &&
                    <CustomButton
                        variant="outlined"
                        color="error"    
                        text="Odstranit"
                        onClick={() => setConfirmation(true)}
                    />
                }
                {confirmation &&
                    <>
                        <CustomButton
                            color="error" 
                            text="Potvrdit"
                            disabled={mutation.isPending}
                            onClick={() => mutation.mutate()}
                        />
                        <CustomButton
                            variant="outlined"
                            text="Zrušit"
                            onClick={() => setConfirmation(false)}
                        />
                    </>
                }
            </Box>
            <Box>
                {mutation.isError ? (
                    <div>Došlo k chybě: {mutation.error.message}</div>
                ) : null}
            </Box>
        </Box>
    )
}
